import createIcon from '../../createIcon';

/**
 * @component @name Category
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNSAyTDYgMTFIMTdMMTEuNSAyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3IDIyQzE5LjQ4NTMgMjIgMjEuNSAxOS45ODUzIDIxLjUgMTcuNUMyMS41IDE1LjAxNDcgMTkuNDg1MyAxMyAxNyAxM0MxNC41MTQ3IDEzIDEyLjUgMTUuMDE0NyAxMi41IDE3LjVDMTIuNSAxOS45ODUzIDE0LjUxNDcgMjIgMTcgMjJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMi41IDEzLjVIMTAuNVYyMS41SDIuNVYxMy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Category = createIcon('Category', [
  ['path', { d: 'M11.5 2L6 11H17L11.5 2Z', key: '1aa3nh' }],
  [
    'path',
    {
      d: 'M17 22C19.4853 22 21.5 19.9853 21.5 17.5C21.5 15.0147 19.4853 13 17 13C14.5147 13 12.5 15.0147 12.5 17.5C12.5 19.9853 14.5147 22 17 22Z',
      key: 'vhytmf',
    },
  ],
  ['path', { d: 'M2.5 13.5H10.5V21.5H2.5V13.5Z', key: 'it2bf5' }],
]);

export default Category;
